module.exports = __webpack_public_path__ + "static/media/tomato.8590886e.png";